// is touch
function isTouchDevice() {
	return (("ontouchstart" in window) || (navigator.maxTouchPoints > 0) || (navigator.msMaxTouchPoints > 0));
}

const timerMax = 99;
let authOnly = false;
let currentTab = 1;

if (isTouchDevice()) {
	$("body").removeClass("des");
	$("body").addClass("mob");
} else {
	$("body").removeClass("mob");
	$("body").addClass("des");
}

const doc = document.documentElement
const appSizes = () => {
	let windowHeight = $(window).height();
	doc.style.setProperty("--app-height", windowHeight + "px");

	let headerHeight = $(".header").outerHeight();
	doc.style.setProperty("--header-height", headerHeight + "px");

	if ($(".archive__nav").length > 0) {
		let archiveNavHeight = $(".archive__nav").outerHeight();
		doc.style.setProperty("--archive-nav-height", archiveNavHeight + "px");
	}

	if ($(".jury-vote__summary").length > 0) {
		let juryVoteSummary = $(".jury-vote__summary").outerHeight();
		doc.style.setProperty("--jury-vote-summary", juryVoteSummary + "px");
	}
}
appSizes();
let timerInterval;


// Установка куки
function setCookie(name, value, days) {
	const date = new Date();
	date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000); // Добавляем дни
	const expires = "expires=" + date.toUTCString();
	document.cookie = `${name}=${value}; ${expires}; path=/`;
}

// Получение куки
function getCookie(name) {
	const cookies = document.cookie.split(';');
	for (let i = 0; i < cookies.length; i++) {
		const cookie = cookies[i].trim();
		if (cookie.startsWith(name + "=")) {
			return cookie.substring((name + "=").length, cookie.length);
		}
	}
	return null;
}

const togglePopup = (popupName, isActive) => {
	$(`.popup[data-popup-name="${popupName}"]`).toggleClass("active", isActive);
};

// Проверка и управление баннером
document.addEventListener('DOMContentLoaded', () => {
	const cookieBanner = document.querySelector(".cookie");
	const cookieBannerBtn = document.querySelector(".cookie__btn");

	// Проверяем куку
	if (!getCookie('cookieAccepted')) {
		cookieBanner.classList.add('active'); // Показываем баннер
	}

	// Обработка кнопки "Понятно"
	cookieBannerBtn.addEventListener('click', () => {
		setCookie('cookieAccepted', 'true', 365); // Устанавливаем куку на 1 год
		cookieBanner.classList.remove('active'); // Скрываем баннер
	});
});


// Resize
$(window).on("resize", function () {
	// is touch
	isTouchDevice();

	// Header nav
	if (window.matchMedia("(min-width: 1280px)").matches && $(".header__nav").hasClass("active")) {
		$("body").removeClass("no-scroll");
		$(".header__nav-toggler").removeClass("active");
		$(".header__nav").removeClass("active");
		if ($(".header--index") && !$(".header--index").hasClass("active")) {
			$(".header").removeClass("bg-active");
		}
	}

	// app heights
	appSizes();
});


// Scroll
const headerIndex = document.querySelector(".header--index");
const mainScreen = document.querySelector(".main-screen");
const toTopBtn = document.querySelector(".fixed-nav__to-top");
$(window).on("scroll", function () {
	// app heights
	appSizes();

	// Header scroll
	if (headerIndex) {
		let st = $(this).scrollTop();
		let headerIndexRect = headerIndex.getBoundingClientRect();
		let mainScreenRect = mainScreen.getBoundingClientRect();
		if (st > 0) {
			headerIndex.classList.add("bg-rgba");
		} else {
			headerIndex.classList.remove("bg-rgba");
		}

		if (mainScreenRect.bottom < headerIndexRect.height) {
			headerIndex.classList.add("active");
		}
		else {
			headerIndex.classList.remove("active");
		}
	}

	// To top btn
	if (toTopBtn) {
		if (window.scrollY > 400) {
			toTopBtn.classList.add("active");
		} else {
			toTopBtn.classList.remove("active");
		}
	}
})

toTopBtn.addEventListener('click', () => {
	window.scrollTo({
		top: 0,
		left: 0,
		behavior: "smooth",
	});
});


// Document click
$(document).on("click", function (e) {
	// Header nav toggler
	if ($(".header__nav").hasClass("active")) {
		var callbackPopup = $(".header__nav-toggler, .header__nav");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".header__nav-toggler").removeClass("active");
			$(".header__nav").removeClass("active");
			$("body").removeClass("no-scroll");
			if ($(".header--index") && !$(".header--index").hasClass("active")) {
				$(".header").removeClass("bg-active");
			}
		};
	}

	// Year choice
	if ($(".year-choice__button").hasClass("active")) {
		var callbackPopup = $(".year-choice__button, .year-choice__popup");
		if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
			$(".year-choice__button").removeClass("active");
			$(".year-choice__popup").removeClass("active");
		};
	}
});


// popups
$(".popup__close, .popup__cancel").on("click", function (e) {
	$("body").removeClass("no-scroll");
	$(this).closest(".popup").removeClass("active");
	if (timerInterval) {
		clearInterval(timerInterval);
		$("p.count-down > b.timer").text(timerMax + ` секунд`);
	}
	// Убрать ошибки
	$(".form__mistakes").html("");
	$(".form__mistakes").hide();

	// popup gallery
	if ($(this).closest(".popup").hasClass("popup-gallery")) {
		popupGallerySlider.destroy(true, true);
		popupGallerySliderList.innerHTML = "";
	}
			
	// popup nominations
	if ($(".popup-nominations-gallery").hasClass("active")) {
		popupNominationsGallerySlider.destroy(true, true);
		popupNominationsGallerySliderList.innerHTML = "";
	}

	if ($(this).closest(".popup").hasClass("popup-project-vote-success")) {
		window.location.reload();
	}
});

$(".popup").on("click", function (e) {
	var callbackPopup = $(".popup__card")
	if (!callbackPopup.is(e.target) && callbackPopup.has(e.target).length === 0) {
		$(this).removeClass("active");
		$("body").removeClass("no-scroll");

		// popup gallery
		if ($(this).hasClass("popup-gallery")) {
			popupGallerySlider.destroy(true, true);
			popupGallerySliderList.innerHTML = "";
		}
			
		// popup nominations
		if ($(this).hasClass(".popup-nominations-gallery")) {
			popupNominationsGallerySlider.destroy(true, true);
			popupNominationsGallerySliderList.innerHTML = "";
		}
	};
});

$("[data-popup-open]").on("click", function (e) {
	e.preventDefault();
	let dataPopupName = $(this).attr("data-popup-open");
	let dataPopupClose = $(this).attr("data-popup-close");
	let popup = $(".popup[data-popup-name=" + dataPopupName + "]");

	if (dataPopupClose === "true") {
		$(this).closest(".popup").removeClass("active");
		popup.addClass("active");
	} else {
		$("body").addClass("no-scroll");
		popup.addClass("active");
	}


	// Проверить, что мы просто хотим войти
	if (this.hasAttribute("data-auth-only")) {
		authOnly = true;
	}


	// загрузить комментарии
	if (dataPopupName === "popup-experts-comment") {
		loadComment($(this).attr("pid"));
	}

	if (dataPopupName === "popup-experts-vote") {
		loadFinal();
	}

	// загрузить комментарии Большого Жюри
	if (dataPopupName === "popup-bj-comment") {
		loadCommentBj($(this).attr("pid"));
	}

	if (dataPopupName === "popup-bj-vote") {
		loadFinalBj();
	}

	// Для голосования из списка проектов мы берем данные из атрибутов
	if (this.hasAttribute("data-type") && this.hasAttribute("data-name")
		&& this.hasAttribute("data-author")) {
		// Retrieve attribute values
		const type = $(this).attr("data-type");
		const name = $(this).attr("data-name");
		const author = $(this).attr("data-author");
		const nom_id = $(this).attr("data-nom_id");
		const prj = $(this).attr("data-prj");

		// Вывести информацию о проекте
		const projectType = $(".popup-project-vote__project-type");
		const projectParams = $(".popup-project-vote__about-title");
		const projectName = $(".popup-project-vote__about-title > div:nth-child(1) > h4:nth-child(1)");
		const projectAuthorsList = $(".popup-project-vote__project-about > div:nth-child(1) > ul:nth-child(3)");

		// Update inner HTML with attribute values
		projectType.html(type);
		projectName.html("«" + name + "»");
		projectParams.attr("nom_id", nom_id);
		projectParams.attr("prj", prj);

		// Assuming author is a JSON string, parse it and update the authors list
		const authors = JSON.parse(author.replace(/&quot;/g, '"'));
		let authorsHtml = '';
		for (const key in authors) {
			authorsHtml += `<li><div><a href="/club/forum/profile/${key}">
		    <b>${authors[key].fio}</b></a>&nbsp;– ${authors[key].etc}<div></li>`;
		}
		projectAuthorsList.html(authorsHtml);
	}

	// Обнулить таймер
	if (timerInterval) {
		clearInterval(timerInterval);
		$("p.whatsapp > b.timer").text(timerMax + ` секунд`);
		// alert("Таймер остановлен");
	}
});

document.addEventListener("keypress", function onEvent(e) {
	if (e.key === "Escape") {
		if ($(".popup").hasClass("active")) {
			e.preventDefault();
		}
	}
});
document.addEventListener("keyup", function onEvent(e) {
	if (e.key === "Escape") {
		if ($(".popup").hasClass("active")) {
			// popup gallery
			if ($(".popup-gallery").hasClass("active")) {
				popupGallerySlider.destroy(true, true);
				popupGallerySliderList.innerHTML = "";
			}
			
			// popup nominations
			if ($(".popup-nominations-gallery").hasClass("active")) {
				popupNominationsGallerySlider.destroy(true, true);
				popupNominationsGallerySliderList.innerHTML = "";
			}

			$(".popup").removeClass("active");
			$("body").removeClass("no-scroll");
		}
	}
});


// Header nav toggler
$(".header__nav-toggler").on("click", function () {
	$("body").toggleClass("no-scroll");
	$(this).toggleClass("active");
	$(".header__nav").toggleClass("active");
	if ($(".header--index") && !$(".header--index").hasClass("active")) {
		$(".header--index").toggleClass("bg-active");
	}
});


// Nominations
$(".nomination-item__toggler").on("click", function () {
	$(".nomination-item__toggler").not(this).removeClass("active");
	$(".nomination-item__toggler").not(this).siblings(".nomination-item__content").slideUp();
	$(this).toggleClass("active");
	$(this).siblings(".nomination-item__content").slideToggle();
});


const popupNominationsGallery = document.querySelector(".popup-nominations-gallery");
const popupNominationsGallerySliderList = document.querySelector(".popup-nominations-gallery-slider__list");
let popupNominationsGallerySlider = null;

$(".nominations-gallery__item-link").on("click", function (e) {
	e.preventDefault();

	let currentProjectPhotosList = $(this).closest(".nominations-gallery__list");
	let galleryItems = currentProjectPhotosList.find(".nominations-gallery__item-image").toArray();

	let { galleryImagesSrcArr, galleryImagesSrcsetArr, galleryImagesAltArr } = galleryItems.reduce((acc, item) => {
		acc.galleryImagesSrcArr.push($(item).attr("src"));
		acc.galleryImagesSrcsetArr.push($(item).attr("srcset"));
		acc.galleryImagesAltArr.push($(item).attr("alt") || "");
		return acc;
	}, { galleryImagesSrcArr: [], galleryImagesSrcsetArr: [], galleryImagesAltArr: [] });


	let currentProjectPhotosLinks = currentProjectPhotosList.find(".nominations-gallery__item-link");
	let indexOfClickedCard = currentProjectPhotosLinks.index(this);


	$("body").addClass("no-scroll");
	$(".popup-nominations-gallery").addClass("active");

	popupNominationsGallerySliderList.innerHTML = galleryItems.map(function (item, i) {
		return '<li class="popup-nominations-gallery-slider__item swiper-slide"><img class="popup-nominations-gallery-slider__item-image" src="' + galleryImagesSrcArr[i] + '" srcset="' + galleryImagesSrcsetArr[i] + '" alt="' + galleryImagesAltArr[i] + '"><div class="popup-nominations-gallery-slider__item-caption">' + galleryImagesAltArr[i] + '</div></li>';
	}).join("");

	popupNominationsGallerySlider = new Swiper(".popup-nominations-gallery-slider", {
		modules: [Navigation, Pagination],
		initialSlide: indexOfClickedCard,
		loop: true,
		navigation: {
			nextEl: ".popup-nominations-gallery-slider__nav-btn--next",
			prevEl: ".popup-nominations-gallery-slider__nav-btn--prev"
		},
		pagination: {
			el: ".popup-nominations-gallery-slider__fraction",
			type: "fraction",
		},
	});
});

document.addEventListener('keydown', function (e) {
	// Если попап не активен, ничего не делаем
	if (document.querySelector('.popup-nominations-gallery').classList.contains('active')) {
		// Если нажата клавиша "Вправо" — переходим к следующему слайду
		if (e.key === 'ArrowRight') {
			e.preventDefault();
			popupNominationsGallerySlider.slideNext();
		}
	
		// Если нажата клавиша "Влево" — переходим к предыдущему слайду
		if (e.key === 'ArrowLeft') {
			e.preventDefault();
			popupNominationsGallerySlider.slidePrev();
		}
	}
});


const popupGallery = document.querySelector(".popup-gallery");
const popupGallerySliderList = document.querySelector(".popup-gallery-slider__list");
let popupGallerySlider = null;

$(".project-photos__item-link").on("click", function (e) {
	e.preventDefault();

	let currentProjectPhotosList = $(this).closest(".project-photos__list");

	let galleryItems = currentProjectPhotosList.find(".project-photos__item-image").toArray();

	let { galleryImagesSrcArr, galleryImagesSrcsetArr, galleryImagesAltArr } = galleryItems.reduce((acc, item) => {
		acc.galleryImagesSrcArr.push($(item).attr("src"));
		acc.galleryImagesSrcsetArr.push($(item).attr("srcset"));
		acc.galleryImagesAltArr.push($(item).attr("alt") || "");
		return acc;
	}, { galleryImagesSrcArr: [], galleryImagesSrcsetArr: [], galleryImagesAltArr: [] });

	let currentProjectPhotosLinks = currentProjectPhotosList.find(".project-photos__item-link");

	let indexOfClickedCard = currentProjectPhotosLinks.index(this);

	$("body").addClass("no-scroll");
	$(".popup-gallery").addClass("active");

	popupGallerySliderList.innerHTML = galleryItems.map(function (item, i) {
		return '<li class="popup-gallery-slider__item swiper-slide"><img class="popup-gallery-slider__item-image" src="' + galleryImagesSrcArr[i] + '" srcset="' + galleryImagesSrcsetArr[i] + '" alt="' + galleryImagesAltArr[i] + '"><div class="popup-gallery-slider__item-caption">' + galleryImagesAltArr[i] + '</div></li>';
	}).join("");

	popupGallerySlider = new Swiper(".popup-gallery-slider", {
		modules: [Navigation, Pagination],
		initialSlide: indexOfClickedCard,
		loop: true,
		navigation: {
			nextEl: ".popup-gallery-slider__nav-btn--next",
			prevEl: ".popup-gallery-slider__nav-btn--prev"
		},
		pagination: {
			el: ".popup-gallery-slider__fraction",
			type: "fraction",
		},
	});
});

document.addEventListener('keydown', function (e) {
	// Если попап не активен, ничего не делаем
	if (document.querySelector('.popup-gallery').classList.contains('active')) {
		// Если нажата клавиша "Вправо" — переходим к следующему слайду
		if (e.key === 'ArrowRight') {
			e.preventDefault();
			popupGallerySlider.slideNext();
			console.log("Right")
		}
	
		// Если нажата клавиша "Влево" — переходим к предыдущему слайду
		if (e.key === 'ArrowLeft') {
			e.preventDefault();
			popupGallerySlider.slidePrev();
			console.log("Left")
		}
	}
});


// News index slider
const newsIndexSlider = document.querySelector(".news-index__slider")
if (newsIndexSlider) {
	let newsIndexSwiper = new Swiper(".news-index__slider", {
		modules: [Navigation, Pagination],
		loop: true,
		slidesPerView: 1,
		slidesPerGroup: 1,
		spaceBetween: 16,
		navigation: {
			nextEl: ".view__navigation-btn--next",
			prevEl: ".view__navigation-btn--prev"
		},
		pagination: {
			el: ".news-index__slider-pagination",
			bulletElement: "button",
			bulletActiveClass: "news-index__slider-pagination-bullet--active",
			bulletClass: "news-index__slider-pagination-bullet",
			clickable: true,
		},
		breakpoints: {
			768: {
				slidesPerView: 2,
				slidesPerGroup: 2,
				spaceBetween: 24
			},
			1024: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 16
			},
			1280: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 24
			},
			1440: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 32
			},
			1600: {
				slidesPerView: 3,
				slidesPerGroup: 3,
				spaceBetween: 40
			}
		}
	});
}


// FAQ
$(".faq-table__item-toggler").on("click", function () {
	$(".faq-table__item-toggler").not(this).removeClass("active");
	$(".faq-table__item-toggler").not(this).siblings(".faq-table__item-answer").slideUp();
	$(this).toggleClass("active");
	$(this).siblings(".faq-table__item-answer").slideToggle();
});


// Jury vote input
$(".jury-vote-card__check-input").on("change", function () {
	$(".jury-vote__summary-loader").addClass("active");
	setTimeout(() => {
		$(".jury-vote__summary-loader").removeClass("active");
	}, 1000);
	$.ajax({
		url: "/ajax.php?mid=53",
		type: 'POST',
		data: {
			user_id: user_id,
			vote_id: vote_id,
			secret: secret,
			res_id: this.getAttribute('res-id')
		},
		dataType: "json",
		success: (res) => {
			var a = $(".jury-vote__summary .jury-vote__summary-main .jury-vote__summary-text .text-block p b span:first-child");
			a.html(res.count);
			if ('last' in res) {
				var a = $(".popup-jury-vote__choice-results .text-block	ol");
				var b = $("<li user-id='" + res.ins_id + "'>").append($("<div>").text(res.last));
				var inserted = false;
				var newText = res.last.toLowerCase();

				a.children("li").each(function () {
					var currentText = $(this).text().toLowerCase();

					if (newText < currentText) {
						$(this).before(b); // Insert before the current <li>
						inserted = true;
						return false; // Break out of .each loop
					}
				});

				if (!inserted) {
					a.append(b); // If no position was found, append it at the end
				}
			}
			else if ('del_id' in res) {
				var a = $("li[user-id='" + res.del_id + "']");
				a.remove();
			} else {
				console.log("error");
			}
		},
		error: (err) => {
			alert('Ошибка, свяжитесь с оргкомитетом')
			// alert('Ошибка')
			console.log(err)
		}
	});
});


// Jury popup vote choice
$(".popup-jury-vote__choice-toggler").on("click", function () {
	$(this).siblings(".popup-jury-vote__choice-results").slideToggle();
	$(this).text(function (i, v) {
		return v === 'Показать список выбранных вами кандидатов' ? 'Скрыть список выбранных вами кандидатов' : 'Показать список выбранных вами кандидатов'
	});
});


// Experts prohects vote popup
$(".popup-experts-vote__section-toggler").on("click", function () {
	$(this).siblings(".popup-experts-vote__section-content").slideToggle();
});


// Project vote like
$(".project__vote-like, .project-card__like").on("click", function () {
	$(this).toggleClass("active");
	$.ajax({
		url: "/ajax.php?mid=5",
		type: 'POST',
		// context: $('body'),
		data: {
			user_id: user_id,
		},
		dataType: "json",
		success: (res) => {

		},
		error: (err) => {

		}
	});
});


// Project votes toggler
$(".project-votes__toggler").on("click", function () {
	$(this).toggleClass("active");
	$(".project-votes__content").slideToggle();
	$(this).children("span").text(function (i, v) {
		return v === 'Показать голоса' ? 'Скрыть голоса' : 'Показать голоса'
	});
});


// Year choice
$(".year-choice__button").on("click", function () {
	$(this).toggleClass("active");
	$(this).siblings(".year-choice__popup").toggleClass("active");
});


// Summary button click
$("button.jury-vote__summary-btn").on("click", () => {
	let backup = [];

	// Select all input elements with IDs starting with "backup_vote_res_id"
	$('input[id^="backup_vote_res_id"]').each(function () {
		backup.push($(this).val()); // Get the value and add it to the array
	});
	$.ajax({
		url: "/ajax.php?mid=53",
		type: 'POST',
		data: {
			user_id: user_id,
			vote_id: vote_id,
			secret: secret,
			action: 'summary',
			backup_vote_res: backup
		},
		dataType: "json",
		success: (res) => {
			if (res['success']) {
				$(".psyche-mistake").html("Нет ошибок");
				$(".psyche-mistake").hide();
				$("body").removeClass("no-scroll");
				$(this).closest(".popup").removeClass("active");
				$(".container.typical-container").html(res.html);
				$(".container.typical-container").css("background-color", "white");
				$('html, body').animate({ scrollTop: 0 }, 'slow');
			} else {
				// $("body").removeClass("no-scroll");
				// $(this).closest(".popup").removeClass("active");
				$(".psyche-mistake").html("Ошибка: " + res.error);
				$(".psyche-mistake").show();
				$('html, body').animate({ scrollTop: 0 }, 'slow');
				$('.popup__close').trigger('click');
			}
		},
		error: (err) => {
			$(".container.typical-container").html("Ошибка:" + res.error);
			$(".container.typical-container").css("background-color", "#f5f3ee");
		}
	});
})

// add on click listener jquery on a.projects__nav-link
$("a.projects__nav-link").on("click", function () {
	$("a.projects__nav-link.active").toggleClass("active");
	$(this).toggleClass("active");
	// Скрыть старый
	var prevList = $(".projects__content:not(.projects__content---hidden)")
	prevList.toggleClass("projects__content---hidden");
	prevList.hide();

	// Показать новый
	var newList = $(".projects__content---hidden#pr" + this.id);
	console.log(newList);
	console.log(this.id);
	newList.toggleClass("projects__content---hidden");
	newList.show();
	// Clear the query parameters
	// window.location.search = '';
	// Get the current URL without the query parameters
	const newUrl = window.location.protocol + "//" + window.location.host + window.location.pathname + "?nom=" + this.id;

	// Use history.pushState to update the URL without reloading the page
	window.history.pushState({}, document.title, newUrl);
});

// Перемотаем все видео на 1й кадр, таким образом будет poster
var videos = document.querySelectorAll('video.project-videos__item-iframe');
for (var i = videos.length - 1; i >= 0; i--) {
	let video = videos[i];
	video.addEventListener('loadedmetadata', () => {
		video.currentTime = 1; // Устанавливаем на первый кадр
		video.addEventListener('seeked', () => {
			console.log('Первый кадр готов!');
		});
	});
}

// Experts vote nav
$(".experts-vote__nav-btn").on("click", function () {
	if (!$(this).hasClass("active")) {
		$(".experts-vote__nav-btn").removeClass("active");
		$(".experts-vote__content").hide();
		$(".experts-vote__summary-nomination").hide().removeClass("experts-vote__summary-nomination---current");
		$(".experts-vote__content-container:not(.experts-vote__content-container---hidden)").addClass("experts-vote__content-container---hidden");

		$(this).addClass("active");

		$(".experts-vote__content").eq($(this).index(".experts-vote__nav-btn")).fadeIn().find(".experts-vote__content-container").removeClass("experts-vote__content-container---hidden");
		$(".experts-vote__summary-nomination").eq($(this).index(".experts-vote__nav-btn")).fadeIn().addClass("experts-vote__summary-nomination---current");
	}
});

// Отправка формы ввода телефона
$("button#checkphone").on("click", () => {
	if (!$("input#personal_agr").is(':checked')) {
		$(".form__mistakes").html("Необходимо подтвердить согласие о персональных данных");
		$(".form__mistakes").show();
		return false;
	}

	if ($("button#checkphone").attr("data-name") !== undefined) {
		$(".popup-project-vote__project-type").text($("button#checkphone").attr("data-name"));
		$(".popup-project-vote__about-title").attr("nom_id", $("button#checkphone").attr("data-nom_id"));
		$(".popup-project-vote__about-title").attr("prj", $("button#checkphone").attr("data-prj"));
		$(".popup-project-vote__about-title > h4").text("«" + $("button#checkphone").attr("data-name") + "»");
		$(".popup-project-vote__project-about > p.list-title").hide();
	}

	const csrf = $("input[name='csrf']").val();
	const phone = $("input[name='phone']").val();
	localStorage.setItem('userPhone', phone);
	// alert(phone + ' ' + csrf);
	$.ajax({
		url: "/ajax.php?mid=5",
		type: 'POST',
		data: {
			csrf: csrf,
			phone: phone,
			action: 'check-phone',
		},
		dataType: "json",
		success: (res) => {
			if (res['success']) {
				// alert("Код отправлен на " + res['messenger']);
				$(".form__mistakes").html('');
				$(".form__mistakes").hide();

				// Close the popup
				$("body").removeClass("no-scroll");
				$(".popup.active").removeClass("active");

				// Меняем popup

				togglePopup("popup-phone-check", false);
				togglePopup("popup-phone-code", true);

				$("b.phone-number").text(res?.phone ?? "Неизвестный номер");

				// Переключаем видимость мессенджеров
				$(".whatsapp").toggle(res?.messenger === "WhatsApp");
				$(".sms").toggle(res?.messenger === "SMS");

				let timeLeft = timerMax;
				if (res['messenger'] == 'SMS') {
					$(".count-down.sms").show();
				} else {
					$(".count-down.whatsapp").show();
				}
				// Таймер
				const getSecondsWord = (seconds) => {
					if (seconds % 10 === 1 && seconds % 100 !== 11) return "секунду";
					if (seconds % 10 >= 2 && seconds % 10 <= 4 && (seconds % 100 < 10 || seconds % 100 >= 20)) return "секунды";
					return "секунд";
				};

				// Function to update the timer display
				const updateTimer = () => {
					$("p.count-down > b.timer").text(`${timeLeft} ${getSecondsWord(timeLeft)}`);
				};

				// Function to decrement the timer
				function countdown() {
					// Check if the countdown is finished
					if (timeLeft <= 0) {
						clearInterval(timerInterval);
						$(".count-down").hide();
						// Активировать кнопки повторной отправки
						$("button#repeat-code-wa").prop("disabled", false);
						$("button#repeat-code-sms").prop("disabled", false);
					}
					// Decrement the time left
					timeLeft--;

					// Update the timer display
					updateTimer();
				}

				// Set interval to decrement the timer every second (1000 milliseconds)
				timerInterval = setInterval(countdown, 1000);

			} else {
				$(".form__mistakes").html("Произошла ошибка при отправке кода отправлен на введенный телефон");
			}
		},
		error: (err) => {
			$(".container.typical-container").html("Ошибка:" + err.error);
			$(".container.typical-container").css("background-color", "#f5f3ee");
		}
	});
});

// Отправка формы голосования
$("button#vote-btn").on("click", () => {
	const nom = $(".popup-project-vote__about-title").attr('nom_id');
	const prj = $(".popup-project-vote__about-title").attr('prj');
	$.ajax({
		url: "/ajax.php?mid=5",
		type: 'POST',
		data: {
			action: 'vote',
			nom: nom,
			prj: prj,
			reason: $("textarea[name='reason']").val(),
		},
		dataType: "json",
		success: (res) => {
			if (res['success']) {
				$("textarea[name='reason']").val('');
				$(".form__mistakes").html('');
				$(".form__mistakes").hide();
				togglePopup("popup-project-vote", false);
				togglePopup("popup-project-vote-success", true);
				// window.location.reload();
			} else {
				$(".form__mistakes").html(res['error']);
				$(".form__mistakes").show();
			}
		},
		error: (err) => {
			$(".form__mistakes").html(res['error']);
			$(".form__mistakes").show();
		}
	});
})


// Функция проверки кода, используется при заполнении ввода кода
function checkCode(inputs) {
	let code = "";
	for (const a of Array.from(inputs)) {
		code += a.value.toString();
	}
	const csrf = 123
	// alert(code + ' ' + csrf);
	$.ajax({
		url: "/ajax.php?mid=5",
		type: 'POST',
		data: {
			csrf: csrf,
			code: code,
			action: 'check-code',
		},
		dataType: "json",
		success: (res) => {
			if (res['success']) {
				$(".form__mistakes").html("");
				$(".form__mistakes").hide();
				togglePopup("popup-phone-code", false);
				togglePopup("popup-project-vote", true);
			} else {
				// Вывести ошибку в поле
				$(".form__mistakes").html("Введен неверный код");
				$(".form__mistakes").show();
			}
		},
		error: (err) => {
			$(".form__mistakes").html("Произошла ошибка, попробуйте снова");
			$(".form__mistakes").show();
		}
	});
}

// Функция повторной отправки кода на телефон из localStorage
function repeatCode() {
	const phone = localStorage.getItem('userPhone');
	const csrf = 123
	$.ajax({
		url: "/ajax.php?mid=5",
		type: 'POST',
		data: {
			csrf: csrf,
			phone: phone,
			action: 'check-phone',
		},
		dataType: "json",
		success: (res) => {
			if (res['success']) {

				$(".form__mistakes").html("");
				$(".form__mistakes").hide();

				let timeLeft = timerMax;
				$("p.count-down > b.timer").text(timerMax + ` секунд`);

				// Таймер
				const getSecondsWord = (seconds) => {
					if (seconds % 10 === 1 && seconds % 100 !== 11) return "секунду";
					if (seconds % 10 >= 2 && seconds % 10 <= 4 && (seconds % 100 < 10 || seconds % 100 >= 20)) return "секунды";
					return "секунд";
				};

				// Function to update the timer display
				const updateTimer = () => {
					$("p.count-down > b.timer").text(`${timeLeft} ${getSecondsWord(timeLeft)}`);
				};

				// Function to decrement the timer
				function countdown() {
					// Check if the countdown is finished
					if (timeLeft <= 0) {
						clearInterval(timerInterval);
						$(".count-down").hide();
						// Активировать кнопки повторной отправки
						$("button#repeat-code-wa").prop("disabled", false);
						$("button#repeat-code-sms").prop("disabled", false);
					}
					// Decrement the time left
					timeLeft--;

					// Update the timer display
					updateTimer();
				}
				if (res['messenger'] == 'SMS') {
					$(".count-down.sms").show();
				} else {
					$(".count-down.whatsapp").show();
				}
				$("button#repeat-code-sms").prop("disabled", true);

				// Set interval to decrement the timer every second (1000 milliseconds)
				timerInterval = setInterval(countdown, 1000);
			} else {
				// Вывести ошибку в поле
				$(".form__mistakes").html("Введен неверный код");
				$(".form__mistakes").show();
			}
		},
		error: (err) => {
			$(".form__mistakes").html("Произошла ошибка, попробуйте снова");
			$(".form__mistakes").show();
		}
	});
}

window.repeatCode = repeatCode;

// Отправка формы авторизации
$("button#login-button").on("click", () => {
	const login = $(".popup-login__form input[name='email']").val();
	const pass = $(".popup-login__form input[name='password']").val();
	const errorField = $(".popup-login__form > .form__main > .form__mistakes");
	$.ajax({
		url: "/ajax.php?mid=12",
		type: 'POST',
		data: {
			auth_1_login: login,
			auth_1_pass: pass,
			auth_1_remember: 'on'
		},
		dataType: "json",
		success: (res) => {
			if (res['success']) {
				// // Close the popup
				// $("body").removeClass("no-scroll");
				// $(".popup.active").removeClass("active");
				// window.location.reload();
				togglePopup("popup-login", false);
				// check if user wants to vote
				// alert(authOnly);
				if (!authOnly) {
					togglePopup("popup-phone-check", true);
				} else {
					authOnly = false;
					window.location.reload();
				}
			} else {
				if (res['activate_link']) {
					errorField.html(res['error'] + "<br>" + "<a target='_blank' href='" + res['activate_link'] + "'>Активировать учетную запись</a>");
				} else {
					errorField.text(res['error']);
				}
				errorField.show();
			}
		},
		error: (err) => {
			if (res['activate_link']) {
				errorField.html(res['error'] + "<br>" + "<a target='_blank' href='" + res['activate_link'] + "'>Активировать учетную запись</a>");
			} else {
				errorField.text(res['error']);
			}
			errorField.show();
		}
	});
})


// ВВОД КОДА
document.addEventListener("DOMContentLoaded", () => {
	$('.popup-phone-code__form').each(function () {
		const form = this;
		const inputs = form.querySelectorAll(".popup-phone-code__input");

		// Установить фокус на первое пустое поле
		const setFocusToFirstEmpty = () => {
			for (const input of inputs) {
				if (input.value === "") {
					input.focus();
					break;
				}
			}
		};

		// Обработчик ввода цифр
		inputs.forEach((input, index) => {
			input.addEventListener("input", (event) => {
				const value = event.target.value;

				// Ограничение ввода только одной цифры
				if (!/^[0-9]$/.test(value)) {
					input.value = "";
					return;
				}

				// Перемещаем фокус на следующее поле, если оно есть
				if (index < inputs.length - 1) {
					inputs[index + 1].focus();
				} else {
					// Если последнее поле заполнено, отправляем форму
					if (Array.from(inputs).every((inp) => inp.value !== "")) {
						checkCode(inputs);
					}
				}
			});

			// Обработчик клавиши Backspace
			input.addEventListener("keydown", (event) => {
				if (event.key === "Backspace") {
					if (input.value === "") {
						if (index > 0) {
							const previousInput = inputs[index - 1];
							previousInput.focus(); // Перемещаем фокус на предыдущее поле
							previousInput.value = ""; // Удаляем значение в предыдущем поле
						}
					} else {
						input.value = ""; // Очищаем текущее поле
					}
					event.preventDefault(); // Предотвращаем стандартное поведение
				}
			});

			// При фокусировании выделяем содержимое поля
			input.addEventListener("mousedown", (event) => {
				if (input.value !== "") {
					event.preventDefault(); // Предотвращаем снятие выделения
					input.select();
				}
			});

			input.addEventListener("focus", () => {
				if (input.value !== "") {
					input.select();
				} else {
					setFocusToFirstEmpty();
				}
			});
		});

		// Обработка вставки из буфера
		inputs.forEach((input) => {
			input.addEventListener("paste", (event) => {
				event.preventDefault();
				const pasteData = (event.clipboardData || window.clipboardData).getData("text");

				if (/^[0-9]+$/.test(pasteData)) {
					// Заполняем поля начиная с первого
					const digits = pasteData.split("");
					inputs.forEach((inp, idx) => {
						inp.value = digits[idx] || "";
					});

					// Устанавливаем фокус на первое пустое поле
					setFocusToFirstEmpty();

					// Если все поля заполнены, отправляем форму
					if (Array.from(inputs).every((inp) => inp.value !== "")) {
						checkCode(inputs);
					}
				}
			});
		});

	});

});

// Голосование экспертов
$(".experts-vote-project__check-input").on("change", function () {
	// alert(this.getAttribute('res-id'));
	console.log(this);
	$.ajax({
		url: "/ajax.php?mid=59",
		type: 'POST',
		data: {
			action: 'vote',
			user_id: user_id,
			vote_id: vote_id,
			secret: secret,
			res_id: this.getAttribute('res-id')
		},
		dataType: "json",
		success: (res) => {
			if (res['success']) {
				let popup = $(".popup[data-popup-name='popup-es-vote-error']");
				popup.removeClass("active");
				// p.experts-vote__summary-nomination:nth-child(3) > b:nth-child(2)
				const cur_count = $(".experts-vote__content-container:not(.experts-vote__content-container---hidden) .experts-vote-project__check-input:checked").length;
				$(".experts-vote__nav-btn.active span.experts-vote__nav-choice").text("Выбрано " + cur_count + " из 3");
				$(".experts-vote__summary-nomination---current b:nth-child(2)").text(cur_count);
				console.log('success');
				// window.location.reload();
			} else {
				let popup = $(".popup[data-popup-name='popup-es-vote-error']");
				popup.addClass("active");
				popup.find(".error-block").html("<h3>" + res['error'] + "</h3>");
				console.log('error');
			}
		},
		error: (err) => {
			let popup = $(".popup[data-popup-name='popup-es-vote-error']");
			popup.addClass("active");
			popup.find(".error-block").html("<h3>" + res['error'] + "</h3>");
			console.log('error');
		}
	});
})

// Попап сохранения результатов голосования
function loadFinal() {
	$.ajax({
		url: "/ajax.php?mid=59",
		type: 'POST',
		data: {
			action: 'load_final',
			user_id: user_id,
			vote_id: vote_id,
			secret: secret,
		},
		dataType: "json",
		success: (res) => {
			let popup = $(".popup[data-popup-name='popup-experts-vote']");
			popup.find(".popup__card").html(res['html']);
			$(".popup-experts-vote__section-toggler").on("click", function () {
				$(this).siblings(".popup-experts-vote__section-content").slideToggle();
			});
		},
		error: (err) => {
			// Ошибок тут быть не должно
			alert('Ошибка, свяжитесь с оргкомитетом')
		}
	});
}

function loadComment(pid) {
	$.ajax({
		url: "/ajax.php?mid=59",
		type: 'POST',
		data: {
			action: 'load_comment',
			user_id: user_id,
			vote_id: vote_id,
			secret: secret,
			pid: pid
		},
		dataType: "json",
		success: (res) => {
			let popup = $(".popup[data-popup-name='popup-experts-comment']");
			popup.find(".popup__card").html(res['html']);
			$("#sendComment").on("click", sendCommentBj); /// !!!!!! Временное решение, поменять на sendComment для голосования ЭС
		},
		error: (err) => {
			// Ошибок тут быть не должно
			alert('Ошибка, свяжитесь с оргкомитетом')
		}
	});
}

function sendComment(pid) {
	$.ajax({
		url: "/ajax.php?mid=59",
		type: 'POST',
		data: {
			action: 'comment',
			user_id: user_id,
			vote_id: vote_id,
			res_id: this.getAttribute('res-id'),
			secret: secret,
			comment: $("#comField").val(),
		},
		dataType: "json",
		success: (res) => {
			if (res['code'] == 'ok') {
				let popup = $(".popup[data-popup-name='popup-experts-comment']");
				popup.removeClass("active");

				popup = $(".popup[data-popup-name='popup-es-vote-error']");
				popup.addClass("active");
				popup.find(".error-block").html("<h3>Комментарий отправлен!</h3>");
				popup.find(".text-block").html("<h3>" + "Спасибо за Ваш комментарий оргкомитету!" + "</h3>");
			} else {
				// Ошибок не должно быть
				let popup = $(".popup[data-popup-name='popup-es-vote-error']");
				popup.addClass("active");
				popup.find(".error-block").html("<h3>" + res['error'] + "</h3>");
			}
		},
		error: (err) => {
			// Ошибок не должно быть
			let popup = $(".popup[data-popup-name='popup-es-vote-error']");
			popup.addClass("active");
			popup.find(".error-block").html("<h3>" + res['error'] + "</h3>");
		}
	});
}


// Голосование Большого Жюри
$(".bj-vote-project__check-input").on("change", function () {
	// alert(this.getAttribute('res-id'));
	console.log(this);
	$.ajax({
		url: "/ajax.php?mid=61",
		type: 'POST',
		data: {
			action: 'vote',
			user_id: user_id,
			vote_id: vote_id,
			secret: secret,
			res_id: this.getAttribute('res-id')
		},
		dataType: "json",
		success: (res) => {
			if (res['success']) {
				let popup = $(".popup[data-popup-name='popup-es-vote-error']");
				popup.removeClass("active");
				// p.experts-vote__summary-nomination:nth-child(3) > b:nth-child(2)
				const cur_count = $(".experts-vote__content-container:not(.experts-vote__content-container---hidden) .bj-vote-project__check-input:checked").length;
				console.log(cur_count)
				$(".experts-vote__nav-btn.active span.experts-vote__nav-choice").text("Выбрано " + cur_count + " из 1");
				if ($(".experts-vote__summary-nomination---current").attr("patr") == undefined) {
					$(".experts-vote__summary-nomination---current b:nth-child(2)").text(cur_count);
				} else {
					if (cur_count == 0) {
						$(".experts-vote__summary-nomination---current").text('Вы не проголосовали')
					} else {
						$(".experts-vote__summary-nomination---current").text('Вы проголосовали')
					}
				}
				console.log('success');
				// window.location.reload();
			} else {
				let popup = $(".popup[data-popup-name='popup-es-vote-error']");
				popup.addClass("active");
				popup.find(".error-block").html("<h3>" + res['error'] + "</h3>");
				console.log('error');
			}
		},
		error: (err) => {
			let popup = $(".popup[data-popup-name='popup-es-vote-error']");
			popup.addClass("active");
			popup.find(".error-block").html("<h3>" + res['error'] + "</h3>");
			console.log('error');
		}
	});
})

// Попап сохранения результатов голосования
function loadFinalBj() {
	$.ajax({
		url: "/ajax.php?mid=61",
		type: 'POST',
		data: {
			action: 'load_final',
			user_id: user_id,
			vote_id: vote_id,
			secret: secret,
		},
		dataType: "json",
		success: (res) => {
			let popup = $(".popup[data-popup-name='popup-bj-vote']");
			popup.find(".popup__card").html(res['html']);
			$(".popup-experts-vote__section-toggler").on("click", function () {
				$(this).siblings(".popup-experts-vote__section-content").slideToggle();
			});
		},
		error: (err) => {
			// Ошибок тут быть не должно
			alert('Ошибка, свяжитесь с оргкомитетом')
		}
	});
}

function loadCommentBj(pid) {
	$.ajax({
		url: "/ajax.php?mid=61",
		type: 'POST',
		data: {
			action: 'load_comment',
			user_id: user_id,
			vote_id: vote_id,
			secret: secret,
			pid: pid
		},
		dataType: "json",
		success: (res) => {
			let popup = $(".popup[data-popup-name='popup-bj-comment']");
			popup.find(".popup__card").html(res['html']);
			$("#sendComment").on("click", sendCommentBj);
		},
		error: (err) => {
			// Ошибок тут быть не должно
			alert('Ошибка, свяжитесь с оргкомитетом')
		}
	});
}

function sendCommentBj(pid) {
	$.ajax({
		url: "/ajax.php?mid=61",
		type: 'POST',
		data: {
			action: 'comment',
			user_id: user_id,
			vote_id: vote_id,
			res_id: this.getAttribute('res-id'),
			secret: secret,
			comment: $("#comField").val(),
		},
		dataType: "json",
		success: (res) => {
			if (res['code'] == 'ok') {
				let popup = $(".popup[data-popup-name='popup-bj-comment']");
				popup.removeClass("active");

				popup = $(".popup[data-popup-name='popup-es-vote-error']");
				popup.addClass("active");
				popup.find(".error-block").html("<h3>Комментарий отправлен!</h3>");
				popup.find(".text-block").html("<h3>" + "Спасибо за Ваш комментарий оргкомитету!" + "</h3>");
			} else {
				// Ошибок не должно быть
				let popup = $(".popup[data-popup-name='popup-es-vote-error']");
				popup.addClass("active");
				popup.find(".error-block").html("<h3>" + res['error'] + "</h3>");
			}
		},
		error: (err) => {
			// Ошибок не должно быть
			let popup = $(".popup[data-popup-name='popup-es-vote-error']");
			popup.addClass("active");
			popup.find(".error-block").html("<h3>" + res['error'] + "</h3>");
		}
	});
}